import React from "react";

type ProductType = "jsm" | "jpd" | "loom" | "confluence";

const ProductContext = React.createContext<ProductType>("jsm");

export const ProductProvider = ({
    children,
    product
}: {
    children: React.ReactNode;
    product: ProductType;
}) => (
    <ProductContext.Provider value={product}>
        {children}
    </ProductContext.Provider>
);

export const useProduct = () => {
    const context = React.useContext(ProductContext);
    if (!context) {
        throw new Error("useProduct must be used within ProductProvider");
    }
    return context;
};
